import { render, staticRenderFns } from "./AccountOpening.vue?vue&type=template&id=3c82b803"
import script from "./AccountOpening.vue?vue&type=script&lang=js"
export * from "./AccountOpening.vue?vue&type=script&lang=js"
import style0 from "./AccountOpening.vue?vue&type=style&index=0&id=3c82b803&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports